import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMovementType } from "src/models/Inventory/MovementType.models";

interface MovementTypeState {
  movementTypes: IMovementType[];
  movementTypeToEdit: IMovementType | null;
}

const initialState: MovementTypeState = {
  movementTypes: [],
  movementTypeToEdit: null,
};

const MovementTypeSlice = createSlice({
  name: "MovementType",
  initialState,
  reducers: {
    setMovementTypeList: (state, action: PayloadAction<IMovementType[]>) => {
      state.movementTypes = action.payload;
    },
    concatListMovementType: (
      state: MovementTypeState,
      action: PayloadAction<IMovementType[]>
    ) => {
      state.movementTypes = [...state.movementTypes.concat(action.payload)];
    },
    setMovementTypeToEdit: (state, action: PayloadAction<IMovementType | null>) => {
      state.movementTypeToEdit = action.payload;
    },
    addMovementType: (state, action: PayloadAction<IMovementType>) => {
      state.movementTypes.push(action.payload);
    },
    updateMovementType: (state, action: PayloadAction<IMovementType>) => {
      let itemIndex = state.movementTypes.findIndex(
        item => item.movementTypeId === action.payload.movementTypeId
      );
      if (itemIndex !== -1) state.movementTypes[itemIndex] = action.payload;
    },
    deleteMovementType: (state, action: PayloadAction<number>) => {
      const newArray = state.movementTypes.filter(
        item => item.movementTypeId !== action.payload
      );
      state.movementTypes = newArray;
    },
  },
});

export const {
  setMovementTypeList,
  concatListMovementType,
  setMovementTypeToEdit,
  addMovementType,
  updateMovementType,
  deleteMovementType,
} = MovementTypeSlice.actions;

export default MovementTypeSlice.reducer;
